import { createSlice } from "@reduxjs/toolkit";
import {
  Project,
  IntegrationDetail,
  UspCategory,
  IntegrationValidationSummary,
  IntegrationScreenshots,
} from "./Types";

type initialStateType = {
  projectsList: Project[];
  projectDetails: Project | null;
  integrationSummaries: Record<number, IntegrationValidationSummary>;
  integrationDetail: IntegrationDetail | null;
  uspDetails: UspCategory[];
  screenshots: IntegrationScreenshots | null;
  status: {
    projectsListLoading: boolean;
    projectDetailsLoading: boolean;
    timelineUpdateLoading: boolean;
    integrationUpdateLoading: boolean;
    integrationUpdateSuccess: boolean | null;
    integrationDetailLoading: boolean;
    projectDescriptionUpdateLoading: boolean;
    uspDetailsLoading: boolean;
    screenshotsLoading: boolean;
    screenshotsSaving: boolean;
  };
};

var initialState: initialStateType = {
  projectsList: [],
  projectDetails: null,
  integrationSummaries: {},
  integrationDetail: null,
  uspDetails: [],
  screenshots: null,
  status: {
    projectsListLoading: false,
    projectDetailsLoading: false,
    timelineUpdateLoading: false,
    integrationUpdateLoading: false,
    integrationUpdateSuccess: null,
    integrationDetailLoading: false,
    projectDescriptionUpdateLoading: false,
    uspDetailsLoading: false,
    screenshotsLoading: false,
    screenshotsSaving: false,
  },
};

const projectsSlice = createSlice({
  name: "projects",
  initialState: initialState,
  reducers: {
    setProjectsList: (state, action) => {
      state.projectsList = action.payload;
    },
    setProjectsListLoading: (state, action) => {
      state.status.projectsListLoading = action.payload;
    },
    setProjectDetails: (state, action) => {
      state.projectDetails = action.payload;
    },
    setIntegrationSummaries: (
      state,
      action: { payload: Record<number, IntegrationValidationSummary> }
    ) => {
      state.integrationSummaries = action.payload;
    },
    setProjectDetailsLoading: (state, action) => {
      state.status.projectDetailsLoading = action.payload;
    },
    setTimelineUpdateLoading: (state, action) => {
      state.status.timelineUpdateLoading = action.payload;
    },
    setIntegrationUpdateLoading: (state, action) => {
      state.status.integrationUpdateLoading = action.payload;
    },
    setIntegrationUpdateSuccess: (state, action) => {
      state.status.integrationUpdateSuccess = action.payload;
    },
    resetIntegrationUpdateStatus: (state) => {
      state.status.integrationUpdateSuccess = null;
    },
    setIntegrationDetail: (state, action) => {
      state.integrationDetail = action.payload;
    },
    setIntegrationDetailLoading: (state, action) => {
      state.status.integrationDetailLoading = action.payload;
    },
    setProjectDescriptionUpdateLoading: (state, action) => {
      state.status.projectDescriptionUpdateLoading = action.payload;
    },
    setUspDetails: (state, action) => {
      state.uspDetails = action.payload;
    },
    setUspDetailsLoading: (state, action) => {
      state.status.uspDetailsLoading = action.payload;
    },
    setScreenshots: (
      state,
      action: { payload: IntegrationScreenshots | null }
    ) => {
      state.screenshots = action.payload;
    },
    setScreenshotsLoading: (state, action) => {
      state.status.screenshotsLoading = action.payload;
    },
    setScreenshotsSaving: (state, action) => {
      state.status.screenshotsSaving = action.payload;
    },
  },
});

export const projectsSliceReducer = projectsSlice.reducer;
export const projectsSliceAction = projectsSlice.actions;

